module.exports = __webpack_public_path__ + "assets/img/27_1242_big.1ff24ee5.jpg";